import React from 'react';

import { H3 } from '../../typography/Typography';
import type { CurrencyEnum } from 'components/domains/payments/FormattedPrice';
import { FormattedPrice } from 'components/domains/payments/FormattedPrice';

import styles from './styles.module.scss';

export const ProductTitle: React.FC<{
  name: string;
  price: number | string | undefined;
  discountPrice: number | string | null;
  currency: CurrencyEnum;
  isCurrent?: boolean;
}> = ({ name, price, currency, discountPrice, isCurrent }) => {
  let content = null;
  if (price && discountPrice === null) {
    content = (
      <H3 className={styles.monthPrice}>
        <FormattedPrice price={price} currency={currency} />
      </H3>
    );
  }
  else if (price && discountPrice !== null) {
    content = (
      <H3 className={styles.monthPrice}>
        <span className={styles.oldPrice}>
          <FormattedPrice price={price} currency={currency} />
        </span>
        <FormattedPrice price={discountPrice} currency={currency} />
      </H3>
    );
  }

  return (
    <div className={styles.titleWrapper}>
      <H3 className={styles.title}>{name}</H3>
      {isCurrent ? null : content}
    </div>
  );
};

ProductTitle.displayName = 'Payments/ProductTitle';
